import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/new-design/images/spinner.gif'
import _imports_1 from '@/assets/new-design/images/magnify.png'


const _hoisted_1 = { class: "dashboard-header" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-header-dialog d-flex align-items-center justify-content-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "spinner",
  src: _imports_0
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dashboard-header-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label-title" }, "Find your 5 star tenants!"),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, " Fill the form below to get a tenant reference ")
], -1)
const _hoisted_6 = { class: "dashboard-header-form" }
const _hoisted_7 = {
  style: {"margin-right":"auto"},
  class: "d-flex align-items-center flex-wrap"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "search-icon"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.first_name) = $event)),
          type: "text",
          placeholder: "First Name",
          class: "dashboard-header-form-input firstname"
        }, null, 512), [
          [_vModelText, _ctx.search.first_name]
        ]),
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.last_name) = $event)),
          type: "text",
          placeholder: "Surname",
          class: "dashboard-header-form-input lastname"
        }, null, 512), [
          [_vModelText, _ctx.search.last_name]
        ]),
        _hoisted_11,
        _createVNode(_component_el_date_picker, {
          type: "date",
          format: _ctx.dateFormat,
          placeholder: "Birthdate",
          modelValue: _ctx.search.date_of_birth,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.date_of_birth) = $event)),
          onChange: _ctx.handleChange,
          class: "dashboard-header-form-input birthdate",
          style: {"margin-top":"-10px","margin-left":"-10px"},
          "v-mask": _ctx.maskDate
        }, null, 8, ["format", "modelValue", "onChange", "v-mask"])
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchTenant && _ctx.searchTenant(...args))),
        class: "btn btn-search"
      }, "Search")
    ])
  ]))
}